import { render, staticRenderFns } from "./DropdownNotificationCentral.vue?vue&type=template&id=52a9e904"
import script from "./DropdownNotificationCentral.vue?vue&type=script&lang=js"
export * from "./DropdownNotificationCentral.vue?vue&type=script&lang=js"
import style0 from "./DropdownNotificationCentral.vue?vue&type=style&index=0&id=52a9e904&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports